import { ref, watch } from "vue";
import EventModel from '@/models/Event.js';
import ArtworkModel from '@/models/Artwork.js';
import ArtistModel from '@/models/Artist.js';

import { API_URI } from "@/helpers/config";

export let Artists = ref([]);
export let Artworks = ref([]);
export let Search = ref("");
export let Favorites = ref([]);
export let Events = ref([]);


const artistsFetch = fetch(API_URI + '/mam_artists_json')
    .then(response => response.json())
    .then(response => response.artists)
    .then(artists => {
        artists = artists.map(a => new ArtistModel(a));
        Artists.value = artists;
        //console.log('Artists', artists);
        return Artists.value;
    });

fetch(API_URI + '/mam_artworks_json')
    .then(response => response.json())
    .then(response => response.artworks)
    .then(artworks => {
        artistsFetch.then(artists => {
            var artistsMap = {};
            artists.forEach(artist => {
                artistsMap[artist.uid] = artist;
            });
            artworks.forEach(artwork => {
                artwork.artist = artistsMap[artwork.uid]
            });
            artworks = artworks.map(e => new ArtworkModel(e));
            Artworks.value = artworks
            //console.log('Artworks', artworks);
        });
    });

fetch(API_URI + '/mam_events_json')
    .then(response => response.json())
    .then(response => response.events)
    .then(events => {
        events = events.map(e => new EventModel(e));
        Events.value = events

        //console.log('Events', events);
    });

const Storage = window.localStorage;
var savedFavorites = Storage.getItem('favorites');
if (savedFavorites) {
    Favorites.value = savedFavorites.split(',');
}

watch(Favorites, (/*_newValue, _oldValue*/) => {
    var stored = Favorites.value;
    if (!stored || !stored.length) {
        stored = []
    }
    stored = stored.join(',');
    Storage.setItem('favorites', stored);
}, { deep: true });
